import type {
  CallSaliencyMapInferenceEndpointParams,
  GetDefectSaliencyMap,
} from "./getDefectSaliencyMap.type";

import {
  getMaterialEndpoint,
  callInferenceEndpoint,
} from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/DefectSuggestions";
import { getInstanceName } from "@/config/environmentUtils";

export const getSaliencyMapMaterialEndpoint = (material = "") => {
  const endpoint = getMaterialEndpoint(material);
  if (!endpoint) {
    return undefined;
  }
  return `${endpoint}-SM`;
};

const callSaliencyMapInferenceEndpoint = ({
  datasets_repetition_index,
  datasets_intervention_id,
  image_dataset_id,
  image_url,
  defect,
  endpoint,
}: CallSaliencyMapInferenceEndpointParams) => {
  const body = {
    client: getInstanceName(),
    class: defect,
    url: image_url,
    datasets_id: image_dataset_id,
    datasets_repetition_index: datasets_repetition_index,
    datasets_intervention_id: datasets_intervention_id,
  };

  return callInferenceEndpoint({ body, endpoint });
};

export const getDefectSaliencyMap = async ({
  defect,
  imageDataset,
  selectedMaterial,
}: GetDefectSaliencyMap) => {
  const endpoint = getSaliencyMapMaterialEndpoint(selectedMaterial);
  // If material is not supported, early return
  if (!endpoint || !imageDataset) {
    return {};
  }

  const inference_results = await callSaliencyMapInferenceEndpoint({
    datasets_repetition_index: imageDataset.repetition_index,
    datasets_intervention_id: imageDataset.intervention_id,
    image_dataset_id: imageDataset.id,
    image_url: imageDataset.data_path,
    defect,
    endpoint,
  });

  return inference_results;
};
